import React from 'react'
import { motion } from 'framer-motion'
import { FaQuoteLeft } from 'react-icons/fa'

const ObjectionSection = () => {
  return (
    <section className="section-padding bg-blue-50">
      <div className="container-max">
        <motion.div 
          className="max-w-4xl mx-auto text-center"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center">
              <FaQuoteLeft className="w-8 h-8 text-primary-600" />
            </div>
          </div>
          
          <blockquote className="text-2xl md:text-3xl font-medium text-gray-900 mb-8 italic">
            "Mon patient a du mal à suivre le point avec les yeux."
          </blockquote>
          
          <div className="bg-white rounded-xl p-8 shadow-sm">
            <p className="text-lg text-gray-700 leading-relaxed">
              C'est un défi courant... Avec EMDR Plus, vous n'êtes plus limité. Si le suivi visuel 
              n'est pas adapté, basculez en un instant sur la stimulation auditive, 
              par vibrations, 
              ou une combinaison des deux. Vous disposez toujours d'une alternative efficace.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default ObjectionSection 